import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Product } from 'src/app/models/product.model';
import { CartService } from 'src/app/services/cart.service';
import { CommonService } from 'src/app/services/common.service';
import { Px2RemService } from 'src/app/services/px2-rem.service';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'app-cart-table',
  templateUrl: './cart-table.component.html',
  styleUrls: ['./cart-table.component.less']
})
export class CartTableComponent implements OnInit {
  @Input() sortType: string = "create_time/asc";
  @Input() productList: any = [];
  @Input() hasErrorMessage:boolean=false;
  @Input() isRequiredDateShouldBeLater:boolean=false;
  @Input() errorMessage:any[] = [];
  @Input() messages:any[] = [];
  @Input() placeErrorMessage:any[] = [];
  @Input() reSimulate: boolean = false;
  @Input() form: any;
  @Input() needSimulate:boolean=false;
  @Input() placeOrderEnable:boolean=false;
  warningCategory: any = {
    product_warning:['007','008'],
    qty_warning: ['012','013'],
    discount_warning:['005','006','030','031','033','034','037','023'],
  };
  debounceTimer: any = null;
  showTips:boolean = true; // show tips above cart table
  showPlaceTips: boolean = true;
  country: string | null = localStorage.getItem('country');
  @Output() itemSelectionChanged = new EventEmitter<any>();
  constructor(private translate:TranslateService,private commonService:CommonService,private cartService: CartService,private px2RemService:Px2RemService,private wishlistService:WishlistService) {}
  ngOnInit(): void {
  }
  onDatePickerChange(newDate: Date, item: Product): void {
    item.expectedDate = this.commonService.formatDateString(newDate);
    this.cartService.updateCartItem(item);
  }
  removeFromCart(productId: number): void {
    this.cartService.removeFromCart(this.form,productId);
  }
  
  disabledDate = (current: Date): boolean => {
    if (this.isAutoPlusSevenNeed()) {
      const targetDate = new Date();
      targetDate.setDate(targetDate.getDate() + 7);
      targetDate.setHours(0, 0, 0, 0);
      return current < targetDate; // disable the date before today
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return current < today; // disable the date before today
    }
  };

  isAutoPlusSevenNeed() {
    const storedCustomer = localStorage.getItem("customer");
    const customerInfo = storedCustomer ? JSON.parse(storedCustomer) : null;
    const salesOrg = this.getOrgCode();
    if (customerInfo !== null && salesOrg === 'CN20-G4-40') {
      return true;
    } else {
      return false;
    }
  }

  getOrgCode(): string {

    const orgs = ["/iam", "/oes"];
    const router = orgs.find(org => window.location.pathname.includes(org));
    const orgMapping = JSON.parse(localStorage.getItem('allOrgRoutes') || '{}');
    const userOrg = JSON.parse(localStorage.getItem('sales_org') || '[]');
    const orgList = orgMapping[`${router}`];
    if (window.location.href.includes("Salesportal/iam/cart/gettoken")) {
      return 'CN20-G1-40';
    }
    if (!orgList || orgList.length === 0) {
      return '';
    }
    if (orgList.includes('CN20-G1-40') && userOrg.includes('CN20-G1-40')) {
      return 'CN20-G1-40';
    }

    const firstMatchingOrg = orgList.find((org: any) => userOrg.includes(org));

    return firstMatchingOrg ? firstMatchingOrg : orgList[0];
  }

  getMessageByPromotion(messages: { code: string; message: string; severity: string }[]): string[]{
    return messages
    .filter(msg => this.warningCategory.discount_warning.includes(msg.code))
    .map(msg => msg.message);
  }

  getMessagesExcludingPromotion(messages: { code: string; message: string; severity: string }[]): { code: string; message: string; severity: string }[] {
    return messages
    .filter(msg => !this.warningCategory.discount_warning.includes(msg.code));
  }

  getPromptMessages(item: any): string[] {
    return Array.isArray(item?.promptMessages) ? item.promptMessages : [];
  }

  hasItemMessages(item: any): boolean {
    return this.getMessagesExcludingPromotion(item?.errorMessages ?? []).length > 0 || this.getPromptMessages(item).length > 0;
  }

  isOesCountry(): boolean {
    const currentCountry = (localStorage.getItem('country') || '').trim().toLowerCase();
    const componentCountry = (this.country || '').trim().toLowerCase();
    const pathName = window.location.pathname.toLowerCase();
    return [currentCountry, componentCountry].includes('/oes') ||
      [currentCountry, componentCountry].includes('oes') ||
      pathName.includes('/oes');
  }

  getMaxDeliveryDate(deliveryInfoList: any[]): string {
    if (!Array.isArray(deliveryInfoList) || deliveryInfoList.length === 0) {
      return '';
    }

    return deliveryInfoList
      .map(deliveryInfo => deliveryInfo?.deliveryDate)
      .filter(Boolean)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      .pop() || '';
  }

  getDeliveryInfoListForDisplay(deliveryInfoList: any[]): any[] {
    if (!this.isOesCountry()) {
      return deliveryInfoList;
    }

    const maxDeliveryDate = this.getMaxDeliveryDate(deliveryInfoList);
    return maxDeliveryDate ? [{ deliveryDate: maxDeliveryDate }] : [];
  }

  shouldShowDeliveryQuantity(): boolean {
    return !this.isOesCountry();
  }

  async moveToWhishList(item:any): Promise<void> {
    let params={
      "id": item.id,
      "quantity": item.quantity
    };
    await this.wishlistService.addToWhishList(params);
  }

  convertPxToRem(px: number): string {
    return this.px2RemService.px2rem(px);
  }

   //When determining if there are errors in the shopping cart, exclude cases like 013, as they have already been corrected during the preceding steps.
   checkError(errorMessages:any){
    return (errorMessages.length === 1 &&
      errorMessages[0].code === '013') ||
      errorMessages.length === 0
  }
  updateFromCart(product: Product): void {
    this.cartService.updateCartItem(product);
  }
      //get messages by type：warning or error
  getMessagesByType(errors:any[],type:string,category?:string):string[]{
    if(!Array.isArray(errors)){
      return [];
    }
    if(category){
      return errors.filter(error => {
        return this.warningCategory[category].includes(error.code);
        }).map(filteredError => {
            return filteredError.message;
        });
    }
    let filteredErrors = errors?.filter(error => error.severity === type);
    return filteredErrors?.map(error => error.message);
  }
  isInPromotion(item: any): boolean {
    return (
      item?.components?.length > 0 &&
      item.components.every((c: any) => c.isGift) &&
      item?.isSimulated
    );
  }

  // get rowspan by data
  getRowSpan(item:any):number{
    let rowSpan = 1;
    if(this.hasItemMessages(item)){
      rowSpan = rowSpan + 1;
    }
    if(item.components.length>0 && item.isSimulated){
      rowSpan = rowSpan + 1;
    }
    return rowSpan;
  }

  toggleSelect(item: any) {
    item.isSelect = !item.isSelect;
    this.itemSelectionChanged.emit(item); // 通知父组件项的选择状态发生了变化
  }
  minusQuantity(item: Product): void {
    if (item.minimumOrderQuantity === 0) {
      item.minimumOrderQuantity = 1; 
     }
    if (item.minimumOrderQuantity && item.quantity > item.minimumOrderQuantity) {
      item.quantity= item.quantity - item.minimumOrderQuantity;
      this.updateFromCart(item);
    }
  }

  addQuantity(item: Product): void {
    if (item.minimumOrderQuantity === 0) {
      item.minimumOrderQuantity = 1; 
     }
    if (item.minimumOrderQuantity && item.quantity) {
      item.quantity= item.quantity + item.minimumOrderQuantity;
      this.updateFromCart(item);
    }
  }
  quantityBlur(newQuantity: number, item: any) {
    item.quantity = newQuantity;
    item.inputQuantity = newQuantity;
  }

  quantityChange(newQuantity: number, item: any) {
    sessionStorage.setItem('isUpdatingProduct','true');
    if(item.quantity==item.inputQuantity){
      return;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      item.quantity = newQuantity;
      item.inputQuantity = newQuantity;
      this.updateFromCart(item);
    }, 1000);
  }
  
}
